export default __webpack_public_path__ + "static/media/bg-video.4bc802e1.png";